
import { Component, Vue } from 'vue-property-decorator';
import { getDeviceStatistics, exportDeviceStatistics } from '@/api/deviceStatistics';
import { productList } from '@/api/device';
import { UserModule } from '@/store/modules/user';
import { IPagination } from '@/types';
import DialogDeviceRecord from '../device/components/DeviceRecord.vue';

@Component({
  name: 'StatisticsStaff',
  components: {
    DialogDeviceRecord
  }
})
export default class extends Vue {

  private pickerOptions:any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); //
        const end = new Date(today); 
        const start = new Date(today); 
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
     const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  }

  private formSearch: any = {
    // time: '',
    timePeriods: '',
    device: '',
    serial: '',
    sn: '',
    brand: '',
    product: '',
    model: '',
    deviceAddress: ''
  }
  private listQuery:any = {
    // ym: '',
    name: '',
    number: '',
    sn: '',
    brand_id: '',
    product_id: '',
    model_id: '',
    address: ''
  }
  private paramYm = ''
  private pagination: IPagination={
    currentPage: 1,
    pageSize: 10,
    total: 0
  }

  handleCurrentChange(size:number) {
    this.pagination.currentPage = size;
    this.getList();
  }

  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getList();
  }

  private initTimePeriods(){
    let dataStrStart = new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + '1 00:00:00';
    let dataStrEnd = new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getDate() + ' 23:59:59';
    this.formSearch.timePeriods = [ new Date(dataStrStart).getTime(), new Date(dataStrEnd).getTime() ];
  }

  private loading = false
  private tableData: any = [];
  private titleData: any ={};

  private sortField = '';
  private sortRule = '';

  private handleSortChange({ prop, order }: any) {
    if (order) {
      this.sortField = prop;
      // sort_rule: 1 倒序(desc) 2 正序(asc)
      this.sortRule = order === 'descending' ? '1' : '2';
    } else {
      this.sortField = '';
      this.sortRule = '';
    }
    this.pagination.currentPage = 1;
    this.getList();
  }

  // 导出Excel
  handleExport() {
    let params:any = {
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      company_name: UserModule.getCompanyName,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      // ym: this.formSearch.time
    };
    if (this.formSearch.timePeriods && this.formSearch.timePeriods.length === 2) {
      params.start_time = parseInt(this.formSearch.timePeriods[0]) / 1000;
      params.end_time = parseInt(this.formSearch.timePeriods[1]) / 1000;
    }
    exportDeviceStatistics(params).then(res => {
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  created() {
    // let paramY = new Date().getFullYear();
    // let paramM = new Date().getMonth() > 9 ? new Date().getMonth() : '0' + new Date().getMonth();
    // this.paramYm = paramY + '-' + paramM;
    // this.formSearch.time = this.paramYm;

    this.initTimePeriods();  

    this.getList();

    this.getBrand('', 1);
  }
  getList() {
    this.listQuery = {
      // ym: this.formSearch.time,
      name: this.formSearch.device,
      number: this.formSearch.serial,
      sn: this.formSearch.sn,
      brand_id: (this.formSearch.brand && this.formSearch.brand.id) ? this.formSearch.brand.id : '',
      product_id: (this.formSearch.product && this.formSearch.product.id) ? this.formSearch.product.id : '',
      model_id: (this.formSearch.model && this.formSearch.model.id) ? this.formSearch.model.id : '',
      address: this.formSearch.deviceAddress
    };
    let params: any = {
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      ...this.listQuery,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize
    };
    if (this.sortField) {
      params.sort_field = this.sortField;
      params.sort_rule = this.sortRule;
    }
    if (this.formSearch.timePeriods && this.formSearch.timePeriods.length === 2) {
      params.start_time = this.formSearch.timePeriods[0] / 1000;
      params.end_time = this.formSearch.timePeriods[1] / 1000;
    }

    this.loading = true;
    getDeviceStatistics(params).then(res => {
      this.loading = false;
      if (res && res.data) {
        this.tableData = res.data.list;
        this.titleData = res.data.titleDes;

        this.pagination.total = parseInt(res.data.count);
        this.pagination.pageSize = parseInt(res.data.page_size);
      } else {
        this.tableData = [];
        this.titleData = {};
      }
    }).catch(error => {
      this.showErrorMsg(error.msg);
    });
  }

  private dialogDeviceRecordVisible = false
  private deviceRecordData:any = ''
  private handleDetail(val: any) {
    this.deviceRecordData = this.tableData[val];
    this.deviceRecordData.device_id = this.tableData[val].device_id;
    this.dialogDeviceRecordVisible = true;
  }

  private closeDeviceRecordHandle(val: any) {
    this.dialogDeviceRecordVisible = val;
  }

  private handleTask(val: any) {
    this.$router.push({
      path: 'staffTask',
      query: {
        user: JSON.stringify(val)
      }
    });
  }

  private brandList = []
  private productList = []
  private moduleList = []

  private getBrand(id: string, type: number) {
    let param: any = {};
    param.company_id = UserModule.getCompanyId;
    param.product_type = type;
    switch (type) {
      case 1:
        break;
      case 2:
        param.brand_id = id;
        break;
      case 3:
        param.brand_id = this.formSearch.brand.id;
        param.product_id = id;
        break;
    }

    productList(param).then((res) => {
      switch (type) {
        case 1:
          if (res.data) {
            this.brandList = res.data.list;
          } else {
            this.brandList = [];
          }

          break;
        case 2:
          if (res.data) {
            this.productList = res.data.list;
          } else {
            this.productList = [];
          }

          break;
        case 3:
          if (res.data) {
            this.moduleList = res.data.list;
          } else {
            this.moduleList = [];
          }

          break;
      }
    }).catch((err) => {
      let msg = err;
    });
  }
  private brandChange(val: any) {
    if (val && val.id) {
      this.formSearch.product = {};
      this.formSearch.model = {};
      this.getBrand(val.id, 2);
    } else {
      this.productList = [];
    }
  }
  private productChange(val: any) {
    if (val && val.id) {
      this.formSearch.model = {};
      this.getBrand(val.id, 3);
    } else {
      this.moduleList = [];
    }
  }
  private brandClear() {
    this.formSearch.brand = {};
    this.formSearch.brand.id = '';
  }
  private productClear() {
    this.formSearch.product = {};
    this.formSearch.product.id = '';
  }
  private moduleClear() {
    this.formSearch.model = {};
    this.formSearch.model.id = '';
  }

  handleSearch() {
    this.pagination.currentPage = 1;
    this.getList();
  }

  handleClear() {
    this.pagination.currentPage = 1;
    this.formSearch = {
      // time: this.paramYm,
      timePeriods: this.formSearch.timePeriods,
      device: '',
      serial: '',
      sn: '',
      brand: '',
      product: '',
      model: '',
      deviceAddress: ''
    };
    this.productList = [];
    this.moduleList = [];
    this.getList();
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
